import { LitElement, html, css } from 'lit';

export class SiteSearchButton extends LitElement {
  static properties = {
    href: { type: String },
    label: { type: String },
    active: { type: Boolean },
  };

  static styles = css`
    :host { display: block; }
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.75rem;
      height: 2.75rem;
      box-sizing: border-box;
      border: 1px solid var(--color-border);
      border-radius: 50%;
      color: var(--color-text-primary);
      background: var(--color-surface);
      text-decoration: none;
      transition: all var(--transition-fast, 0.15s ease);
    }
    a:hover, a[aria-current="page"] {
      color: var(--color-accent);
      border-color: var(--color-border-hover);
      transform: translateY(-1px);
    }
    a:focus-visible {
      outline: 3px solid color-mix(in srgb, var(--color-accent) 45%, transparent);
      outline-offset: 2px;
    }
  `;

  constructor() {
    super();
    this.href = '/';
    this.label = 'Search';
    this.active = false;
  }

  render() {
    return html`<a href=${this.href} aria-label=${this.label} title=${this.label}
      aria-current=${this.active ? 'page' : 'false'}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" aria-hidden="true">
        <circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
    </a>`;
  }
}

customElements.define('site-search-button', SiteSearchButton);
